import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

var _styled$div$withConfi, _styled$div$withConfi2;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import styled from 'styled-components';
import { TextField } from '@frameio/vapor';
import { position, transparentize } from 'polished';
import { HEADER_HEIGHT } from '../../utils/constants';
import { colors } from '../../utils/colors';
import breakpoints, { sizes } from '../../utils/breakpoints';
import smallCaps from '../../utils/typography';
var DesktopStyledTextField = styled(TextField).withConfig({
  displayName: "styled__DesktopStyledTextField",
  componentId: "@frameio/developer-components__sc-14d8lia-0"
})({
  background: 'none',
  color: 'rgb(202, 208, 216) !important',
  input: {
    caretColor: 'black !important',
    color: 'black !important'
  },
  borderRadius: '9px',
  paddingLeft: '4px',
  border: '1px solid #CAD0D8',
  ':not(:focus-within)': {
    boxShadow: 'none',
    input: {
      color: 'black !important'
    }
  }
});
var MobileStyledTextField = styled(TextField).withConfig({
  displayName: "styled__MobileStyledTextField",
  componentId: "@frameio/developer-components__sc-14d8lia-1"
})({
  background: 'none',
  color: 'rgb(202, 208, 216) !important',
  input: {
    caretColor: 'black !important',
    color: 'black !important'
  },
  borderRadius: '9px',
  marginTop: '20px',
  border: '1px solid #CAD0D8',
  ':not(:focus-within)': {
    boxShadow: 'none',
    input: {
      color: 'black !important'
    }
  }
});
var boxShadowColor = transparentize(0.9, 'black');
var boxShadow = "".concat(boxShadowColor, " 0 2px 12px");
var DesktopContainer = styled.div.withConfig({
  displayName: "styled__DesktopContainer",
  componentId: "@frameio/developer-components__sc-14d8lia-2"
})((_styled$div$withConfi = {
  width: '100%',
  flexGrow: 1,
  color: colors.text2,
  position: 'relative',
  zIndex: 10
}, _defineProperty(_styled$div$withConfi, breakpoints.md, {
  marginRight: 0
}), _defineProperty(_styled$div$withConfi, '.algolia-autocomplete', {
  width: '500px',
  margin: '0 -24px 0 0',
  '.ds-dropdown-menu': {
    margin: '0 auto',
    width: '100%',
    maxWidth: '100%',
    minWidth: 'auto',
    maxHeight: "calc(100vh - ".concat(HEADER_HEIGHT, "px - 32px)"),
    marginTop: 14,
    background: 'none !important',
    overflowX: 'hidden',
    overflowY: 'auto',
    '&::before': {
      display: 'none'
    },
    '[class^=ds-dataset-]': {
      padding: 0,
      border: 'none !important'
    },
    '.ds-suggestions': {
      marginTop: 0
    },
    '.ds-suggestion': {
      cursor: 'pointer',
      padding: '12px 12px',
      '&.ds-cursor': {
        backgroundColor: transparentize(0.5, colors.divider)
      }
    }
  },
  '.algolia-docsearch-suggestion': {
    padding: 0,
    color: colors.text4,
    background: 'none !important',
    textDecoration: 'none',
    '&--wrapper': {
      paddingTop: 0
    },
    '&--category-header': _objectSpread({
      marginTop: 0,
      marginBottom: '16px',
      paddingBottom: '8px',
      background: 'none !important',
      borderBottom: "1px solid ".concat(colors.divider),
      fontSize: 14,
      color: colors.text1
    }, smallCaps),
    '&--subcategory-column': {
      marginBottom: 4,
      color: colors.text4,
      textAlign: 'left',
      padding: '5.33333px 8px 5.33333px 0'
    },
    '&--title': {
      textAlign: 'left',
      marginBottom: '4px',
      fontSize: 14,
      fontWeight: 'bold',
      color: colors.text1,
      // textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'wrap',
      lineClamp: 3
    },
    '&--highlight': {
      padding: '0px',
      boxShadow: 'none !important',
      color: "".concat(colors.primary, " !important"),
      background: 'none !important'
    },
    '&--no-results': {
      padding: 32
    }
  },
  '.algolia-docsearch-footer': {
    textAlign: 'right',
    margin: '12px 12px 12px 0',
    color: colors.text2
  }
}), _styled$div$withConfi));
var MobileContainer = styled.div.withConfig({
  displayName: "styled__MobileContainer",
  componentId: "@frameio/developer-components__sc-14d8lia-3"
})((_styled$div$withConfi2 = {
  width: '100%',
  flexGrow: 1,
  color: colors.text2,
  position: 'relative',
  zIndex: 10
}, _defineProperty(_styled$div$withConfi2, "@media (max-width: ".concat(sizes.md, "px)"), {
  '.algolia-autocomplete .algolia-docsearch-suggestion--content': {
    float: 'left',
    width: '100%'
  },
  '.algolia-autocomplete .algolia-docsearch-suggestion--subcategory-column': {
    display: 'none'
  }
}), _defineProperty(_styled$div$withConfi2, '.algolia-autocomplete', {
  width: '100%',
  margin: '0',
  border: 'none',
  '.ds-dropdown-menu': {
    margin: '0 auto',
    width: '100%',
    maxWidth: '100%',
    minWidth: 'auto',
    maxHeight: "calc(100vh - ".concat(HEADER_HEIGHT, "px - 32px)"),
    marginTop: 14,
    boxShadow: 'none',
    border: 'none !important',
    background: 'none !important',
    overflowX: 'hidden',
    overflowY: 'scroll',
    '&::before': {
      display: 'none'
    },
    '[class^=ds-dataset-]': {
      padding: 0,
      border: 'none'
    },
    '.ds-suggestions': {
      marginTop: 0
    },
    '.ds-suggestion': {
      cursor: 'pointer',
      padding: '20px 0px',
      '&.ds-cursor': {
        background: 'none !important',
        backgroundColor: 'white !important'
      }
    }
  },
  '.algolia-docsearch-suggestion': {
    padding: 0,
    color: colors.text4,
    background: 'none !important',
    textDecoration: 'none',
    '&--wrapper': {
      paddingTop: 0,
      margin: 0
    },
    '&--category-header': _objectSpread({
      marginTop: 0,
      marginBottom: '16px',
      paddingBottom: '12px',
      background: 'none !important',
      borderBottom: "1px solid ".concat(colors.divider),
      fontSize: 14,
      color: colors.text1
    }, smallCaps),
    '&--subcategory-column': {
      marginBottom: 4,
      color: colors.text4,
      textAlign: 'right',
      padding: '8px 0',
      '&::after': {
        display: 'none'
      },
      '&-text': {
        display: 'none'
      }
    },
    '&--content': {
      textAlign: 'left',
      background: 'none'
    },
    '&--title': {
      textAlign: 'left',
      marginBottom: '4px',
      fontSize: 14,
      fontWeight: 'bold',
      color: colors.text1,
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'wrap',
      lineClamp: 3,
      background: 'none'
    },
    '&--highlight': {
      padding: '0px',
      boxShadow: 'none !important',
      color: "".concat(colors.primary, " !important"),
      background: 'none !important'
    },
    '&--no-results': {
      padding: 32
    }
  },
  '.algolia-docsearch-footer': {
    textAlign: 'right',
    margin: '12px 12px 12px 0',
    color: colors.text2
  }
}), _styled$div$withConfi2));
var MobileOverlay = styled.div.withConfig({
  displayName: "styled__MobileOverlay",
  componentId: "@frameio/developer-components__sc-14d8lia-4"
})(position('fixed', 0), function (props) {
  return !props.visible && {
    opacity: 0,
    visibility: 'hidden'
  };
}, {
  backgroundColor: 'white',
  transitionProperty: 'opacity, visibility',
  transitionDuration: '100ms',
  transitionTimingFunction: 'ease-in-out',
  zIndex: 5
});
var DesktopOverlay = styled.div.withConfig({
  displayName: "styled__DesktopOverlay",
  componentId: "@frameio/developer-components__sc-14d8lia-5"
})(position('fixed', 0), function (props) {
  return !props.visible && {
    opacity: 0,
    visibility: 'hidden'
  };
}, {
  backgroundColor: transparentize(0.7, colors.text2),
  transitionProperty: 'opacity, visibility',
  transitionDuration: '150ms',
  transitionTimingFunction: 'ease-in-out',
  zIndex: 5
});
var MobileSearchWrapper = styled.div.withConfig({
  displayName: "styled__MobileSearchWrapper",
  componentId: "@frameio/developer-components__sc-14d8lia-6"
})(function (props) {
  return !props.visible && {
    opacity: 0,
    visibility: 'hidden'
  };
}, {
  display: 'flex',
  width: 'calc(100vw - 32px)',
  zIndex: 10,
  position: 'absolute',
  left: 16,
  top: 0
});
var DesktopSearchWrapper = styled.div.withConfig({
  displayName: "styled__DesktopSearchWrapper",
  componentId: "@frameio/developer-components__sc-14d8lia-7"
})({
  display: 'flex',
  flexGrow: 3,
  width: '150px',
  maxWidth: '500px',
  zIndex: 10,
  padding: '0 36px'
});
export { MobileOverlay, MobileSearchWrapper, MobileContainer, MobileStyledTextField, DesktopOverlay, DesktopSearchWrapper, DesktopContainer, DesktopStyledTextField };